import { render } from "./confirm-popup.vue?vue&type=template&id=fbb08958"
import script from "./confirm-popup.vue?vue&type=script&lang=js"
export * from "./confirm-popup.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1199873226/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__